// extracted by mini-css-extract-plugin
export default {"div-fields-tag-costcenter":"Area_div-fields-tag-costcenter__7LDIy","div-fields-divider":"Area_div-fields-divider__Lv5TR"};